import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useSimpleAuth } from '../../contexts/SimpleAuthContext';
import './AuthForms.css';

export const EmailVerification: React.FC = () => {
  const [searchParams] = useSearchParams();
  const verificationToken = searchParams.get('token');
  
  const [isVerifying, setIsVerifying] = useState(true);
  const [verificationStatus, setVerificationStatus] = useState<'success' | 'error' | null>(null);
  
  const { verifyEmail } = useSimpleAuth();

  useEffect(() => {
    const performVerification = async () => {
      if (!verificationToken) {
        setVerificationStatus('error');
        setIsVerifying(false);
        return;
      }

      try {
        const success = await verifyEmail(verificationToken);
        setVerificationStatus(success ? 'success' : 'error');
      } catch (err) {
        setVerificationStatus('error');
      } finally {
        setIsVerifying(false);
      }
    };

    performVerification();
  }, [verificationToken, verifyEmail]);

  if (isVerifying) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h2 className="auth-title">Verifying Your Email</h2>
          <p className="auth-subtitle">Please wait while we verify your email address...</p>
          <div style={{ textAlign: 'center', margin: '32px 0' }}>
            <div className="loading-spinner" />
          </div>
        </div>
      </div>
    );
  }

  if (verificationStatus === 'success') {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h2 className="auth-title">Email Verified!</h2>
          <div className="auth-success">
            Your email has been successfully verified. You can now sign in to your account.
          </div>
          <Link to="/auth/login" className="auth-submit-button" style={{ textAlign: 'center', display: 'block' }}>
            Sign In to Your Account
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2 className="auth-title">Verification Failed</h2>
        <div className="auth-error">
          We couldn't verify your email address. The verification link may have expired or is invalid.
        </div>
        <p className="auth-subtitle">
          Please try signing in to your account. If your email is not verified, you can request a new verification email.
        </p>
        <Link to="/auth/login" className="auth-submit-button" style={{ textAlign: 'center', display: 'block' }}>
          Go to Sign In
        </Link>
      </div>
    </div>
  );
};